import {SET_GEOGRAPHY, SET_MANAGEMENT} from "../types";

export const setGeoChoice = (element) => dispatch => {
    dispatch({
        type: SET_GEOGRAPHY,
        payload: element
    })
}

export const setManChoice = (element) => dispatch => {
    dispatch({
        type: SET_MANAGEMENT,
        payload: element
    })
}


// WEBPACK FOOTER //
// ./src/actions/CreateSiteActions/dimensionActions.js